import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { ItemSearchModel } from '../../model/autogen/ItemSearchModel';
import { MediaLinesRequestFactory } from '../../model/autogen/MediaLinesController';
import { IAuthContextProps, withAuthContext } from '../with-auth-context';
import { DocumentDisplay } from '../display/common';
import { MediaLinesModel } from '../../model/autogen/MediaLinesModel';

type RecentMediaLinesDocItemComponentProps = ItemSearchModel & IAuthContextProps

interface RecentMediaLinesDocItemComponentState extends MediaLinesModel { }

class RecentMediaLinesDocItemComponent extends React.Component<RecentMediaLinesDocItemComponentProps, RecentMediaLinesDocItemComponentState> {
    constructor(props: RecentMediaLinesDocItemComponentProps) {
        super(props);
        this.loadContent();
    }

    private loadContent = async () => {
        const model = await this.props.callApi((fetcher) => MediaLinesRequestFactory.getById(fetcher, this.props.documentId, false));
        this.setState({ ...model });
    }

    public render() {
        const props = this.props;
        return (
            <div>
                <ExpansionPanel defaultExpanded={window.innerWidth > 900}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h5">{props.title}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{ width: '100%' }}>
                        {this.state ? <div>
                            <DocumentDisplay lite={true} item={this.state} />
                        </div> : <div>Loading...</div>}
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <br />
            </div>
        );
    }
}

export const RecentMediaLinesDocItem = withAuthContext(RecentMediaLinesDocItemComponent);


// WEBPACK FOOTER //
// ./src/components/doclist/doc-item.tsx